var WishlistAddon = (function ($) {
    var headerUpdateOnLocalStorageChange;

    var setHeaderUpdateOnLocalStorageChange = function (headerUpdateFunction) {
        headerUpdateOnLocalStorageChange = function (wishList) {
            headerUpdateFunction(wishList);
        }
    };

    var updateHeaderAccordingToLocalStorage = function () {
        let localStorageWishList = WishlistAddon.getLocalStorageWishlist();
        headerUpdateOnLocalStorageChange(localStorageWishList);
    };

    var content; //for information message
    var addByWidget = function (productCode, token) {
        var productButton = document.querySelectorAll('button[data-product-code="' + productCode + '"]')[0];
        $(productButton).prop("disabled", true);
        $.ajax({
            type: "POST",
            url: "/wishlist/add",
            beforeSend: function(xhr) {
                xhr.setRequestHeader("X-CSRF-TOKEN", $("input[name='_csrf']").val());
            },
            data: {
                code: productCode,
                token: token
            },
            success: function (data, textStatus, jqXHR) {
                if (jqXHR.status === 204) {
                    addWishListItemLocalStorage(productCode);
                }

                $(productButton).prop("disabled", false);
                $(productButton).addClass("active");
                $(productButton).attr('data-wishItemId', data);
                $(productButton).attr('title', ACC.wishlistRemoveItem);

                if (jqXHR.status !== 204) {
                    $(".wishlist-menu-heart").load(window.location.href + " .wishlist-menu-heart");
                } else {
                    if (headerUpdateOnLocalStorageChange) {
                        headerUpdateOnLocalStorageChange(wishList);
                    }
                }

                setTimeout(function () {
                    var wrapperDiv = new BackgroundBox('wrapperBackground', content);
                    wrapperDiv.show();
                    wrapperDiv.hideWithDelay();
                }, 300);
            },
            error: function (e) {
                $(productButton).prop("disabled", false);
            }
        });
    };

    var removeByWidget = function (wishItemId, token) {
        var productButton = document.querySelectorAll('button[data-wishItemId="' + wishItemId + '"]')[0];
        $(productButton).prop("disabled", true);
        $.ajax({
            url: "/wishlist/remove",
            type: "POST",
            beforeSend: function(xhr) {
                xhr.setRequestHeader("X-CSRF-TOKEN", $("input[name='_csrf']").val());
            },
            data: {
                id: wishItemId,
                token: token
            },
            success: function (data, textStatus, jqXHR) {
                if (jqXHR.status === 204) {
                    removeWishListItemLocalStorage(wishItemId);
                }

                $(productButton).prop("disabled", false);
                $(productButton).removeClass("active");
                $(productButton).attr('title', ACC.wishlistAddItem);
                WishlistAddon.updateWishlistWhenRemove();

                setTimeout(function () {
                    var wrapperDiv = new BackgroundBox('wrapperBackground', content);
                    wrapperDiv.show();
                    wrapperDiv.hideWithDelay();
                }, 300);
            },
            error: function () {
                $(productButton).prop("disabled", false);
            }
        });
    };

    var addWishlistToCart = function () {
        var button = document.getElementById("addAllProductsToCart");
        $(button).prop("disabled", true);

        var products = [];
        var wishItems = $(button).closest("#content_wishlistTab").find(".wishitem-product");
        if (wishItems.length > 0) {
            $(wishItems).each(function () {
                var quantity = $(this).find("input.tireNumberSelect").val();
                products.push({
                    "code": $(this).find("input[name=code]").val(),
                    "quantity": quantity
                });
            });
        }

        $.ajax({
            type: "GET",
            url: "/wishlist/cart/add/wishlist",
            success: function (data, textStatus, jqXHR) {
                if (jqXHR.status === 204) {
                    addLocalStorageWishListDataToCart(data, products, button);
                } else {
                    addWishListDataToCart(data, products, button);
                }
            },
            error: function (data) {
                handleCartLimitExceeded(data);
                $(button).prop("disabled", false);
            }
        });
    };

    var addLocalStorageWishListDataToCart = function (data, products, button) {
        let wishListLocalStorage = {
            wishProducts: WishlistAddon.getWishListOrDefault().wishProducts
        }
        wishListLocalStorage = JSON.stringify(wishListLocalStorage);

        $.ajax({
            type: "POST",
            url: "/wishlist/cart/add/wishlist",
            beforeSend: function(xhr) {
                xhr.setRequestHeader("X-CSRF-TOKEN", $("input[name='_csrf']").val());
            },
            contentType: "application/json; charset=utf-8",
            data: wishListLocalStorage,
            success: function (data) {
                addWishListDataToCart(data, products, button);
            },
            error: function (data) {
                handleCartLimitExceeded(data);
                $(button).prop("disabled", false);
            }
        });
    }

    var handleCartLimitExceeded = function (data) {
        if (data.status === 400 && data.responseText) {
            $('#limitCartEntriesMessage').text(data.responseText);
            $('#limitCartEntriesModal').modal('show');
        }
    }

    var addWishListDataToCart = function (data, products, button) {
        var productCartData = {
            "items": products,
            "price": '',
            "discountedPrice": data
        };
        $(button).prop("disabled", false);
        $( document ).trigger( "changeCartEvent", productCartData);
    }

    var remove = function (scope, id, token) {
        $.ajax({
            url: "/wishlist/remove",
            type: "POST",
            beforeSend: function(xhr) {
                xhr.setRequestHeader("X-CSRF-TOKEN", $("input[name='_csrf']").val());
            },
            data: {
                id: id,
                token: token
            },
            success: function (data, textStatus, jqXHR) {
                if (jqXHR.status === 204) {
                    removeWishListItemLocalStorage(id);
                }

                $(scope).closest('.wishitem-product').remove();
                if ($(".wishitem-products")[0].childElementCount == 0) {
                    $(".empty-wishlist")[0].classList.remove('hide');
                    $(".wishlist-add-all")[0].classList.add('hide');
                }
                WishlistAddon.checkAddAllButton();
                WishlistAddon.updateWishlistWhenRemove();
            }
        });
    };


    function submitWishlistWidget(form) {

        var wishlistButton = form.getElementsByClassName("wishlistButton")[0];
        if (wishlistButton.classList.contains("active")) {
            var wishItemId = wishlistButton.getAttribute("data-wishItemId");
            var token = wishlistButton.getAttribute("data-wishlist-token");
            WishlistAddon.removeByWidget(wishItemId, token);
            content = wishlistButton.getAttribute("data-wishlist-remove-success");
        } else {
            var productCode = wishlistButton.getAttribute("data-product-code");
            var token = wishlistButton.getAttribute("data-wishlist-token");
            WishlistAddon.addByWidget(productCode, token);
            content = wishlistButton.getAttribute("data-wishlist-add-success");
        }

    }

    function checkAddAllButton() {
        var addAllToCartButton = document.getElementById("addAllProductsToCart");
        $(addAllToCartButton).prop("disabled", true);
        $addWishlistButtons = $(".wishitem-products").find(".add-to-cart-wishitem");
        $addWishlistButtons.each(function (i, btn) {
            if(btn) {
                if (btn.disabled == false) {
                    $(addAllToCartButton).prop("disabled", false);
                }
            }
        });
    }

    function updateWishlistWhenRemove() {
        var number = parseInt($(".wishlist-size").text(), 10);
        if (number > 1) {
            $(".wishlist-size").html(number - 1);
        } else {
            $(".wishlist-shortcut").css("display", "none");
        }
    }

    var addWishListItemLocalStorage = function (productCode) {
        wishList = getWishListOrDefault();
        wishList.count += 1;
        wishList.wishProducts[wishList.count] = productCode;
        setLocalStorageWishlist(wishList);

        $("button[data-product-code=" + productCode + "]").attr("data-wishItemId", wishList.count);
    }


    var containsProductWithCode = function (wishList, code) {
        if (wishList === null) {
            return false;
        }

        for (let wishListItemCode of Object.values(wishList.wishProducts)) {
            if (wishListItemCode === code) {
                return true;
            }
        }

        return false;
    }

    var removeWishListItemLocalStorage = function (id) {
        wishList = getWishListOrDefault();
        delete wishList.wishProducts[id];
        setLocalStorageWishlist(wishList);
    }

    var getWishListOrDefault = function () {
        wishList = getLocalStorageWishlist();

        if (!wishList) {
            wishList = {
                count: 0,
                wishProducts: {}
            }
        }

        return wishList
    }

    var setLocalStorageWishlist = function(wishList) {
        window.localStorage.setItem('wishList', JSON.stringify(wishList));
    }

    var getLocalStorageWishlist = function() {
        return JSON.parse(window.localStorage.getItem('wishList'));
    }

    var getLocalStorageWishlistForServer = function() {
        let wishListLocalStorage = {
            wishProducts: getWishListOrDefault().wishProducts
        }

        return JSON.stringify(wishListLocalStorage);
    }

    var updateHeaderHeartRDLite = function(wishList) {
        if (wishList === null) {
            return;
        }

        let wishListSize = Object.keys(wishList.wishProducts).length;
        let isAccount = $(".user-account_quick-access-list").children().length != 0;

        if (wishListSize && !isAccount) {
            $(".wishlist-menu-heart").find(".wishlist-shortcut").remove();
            let wishlistShortcut = $(`<li class="wishlist-shortcut test">
                                          <a href="/wishlist/products">
                                              <i class="fa fa-heart fa-1x" aria-hidden="true" id="LikeList"></i>
                                              <i class="wishlist-size">` + Object.keys(wishList.wishProducts).length + `</i>
                                          </a>
                                      </li>`);
            $(".wishlist-menu-heart").append(wishlistShortcut);

            let itemClass = $(".wishlist-menu-heart").attr("class");
            itemClass = itemClass.replace("account-wishlist", "");
            $(".wishlist-menu-heart").attr("class", itemClass);
        }
    }

    var init = function() {
        $removeWishlistButtons = $(".wishitem-product").find(".removeWishItem");

        $removeWishlistButtons.on('click', function (e) {
            var removeButton = e.currentTarget;
            var wishItemId = removeButton.getAttribute("data-wishitem-id");
            var wishlistToken = removeButton.getAttribute("data-wishlist-token");
            WishlistAddon.remove(removeButton, wishItemId, wishlistToken);
        });

        $(".wishitem-product-content").on('click', function() {
            window.location = $(this).find('.wishitem-specs a').attr("href");
        });

        WishlistAddon.checkAddAllButton();
    }

    return {
        init: init,
        remove: remove,
        addByWidget: addByWidget,
        removeByWidget: removeByWidget,
        addWishlistToCart: addWishlistToCart,
        checkAddAllButton: checkAddAllButton,
        submitWishlistWidget: submitWishlistWidget,
        updateWishlistWhenRemove: updateWishlistWhenRemove,
        setHeaderUpdateOnLocalStorageChange: setHeaderUpdateOnLocalStorageChange,
        updateHeaderAccordingToLocalStorage: updateHeaderAccordingToLocalStorage,
        getLocalStorageWishlist: getLocalStorageWishlist,
        setLocalStorageWishlist: setLocalStorageWishlist,
        getLocalStorageWishlistForServer: getLocalStorageWishlistForServer,
        getWishListOrDefault: getWishListOrDefault,
        updateHeaderHeartRDLite: updateHeaderHeartRDLite,
    }
})(jQuery);

$(document).ready(function () {
    WishlistAddon.init();
});